import { render, staticRenderFns } from "./CallContentBubble.vue?vue&type=template&id=0bcc70b6&scoped=true&"
import script from "./CallContentBubble.vue?vue&type=script&lang=js&"
export * from "./CallContentBubble.vue?vue&type=script&lang=js&"
import style0 from "./CallContentBubble.vue?vue&type=style&index=0&id=0bcc70b6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc70b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VListItemActionText,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet})
